// Id of context menu to show it
// eslint-disable-next-line import/prefer-default-export
export const PATCH_GROUP_CONTEXT_MENU_ID = 'PATCH_GROUP_CONTEXT_MENU_ID';
export const FILTER_CONTEXT_MENU_ID = 'FILTER_CONTEXT_MENU_ID';



// WEBPACK FOOTER //
// ../../src/projectBrowser/constants.js